<template>
  <v-row justify="center">
    <v-dialog v-model="reveal" persistent max-width="400">
      <v-card
        :loading="loading"
        class="ma-auto pa-lg-2 deleteAccount"
        elevation="1"
      >
        <v-card-title class="h2 title text-center heading">
          <v-icon large class="mr-1">mdi-logout</v-icon>
          {{ $t("dashboard.logOutDialog.logOutConfirm") }}
        </v-card-title>
        <v-card-subtitle class="mt-5 px-3">
          <h2 class="text-heading mx-5 title">
            {{ $t("dashboard.logOutDialog.logOutMessage") }}
          </h2>
        </v-card-subtitle>
        <v-card-actions class="mx-4 px-5">
          <v-btn
            color="red"
            class="white--text"
            data-testid="logout"
            small
            @click="logout()"
            :disabled="loading"
          >
            {{ $t("dashboard.logOutDialog.logOut") }}
          </v-btn>
          <v-btn
            color="primary"
            data-testid="cancel"
            small
            @click="cancel()"
            :disabled="loading"
          >
            {{ $t("dashboard.logOutDialog.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "LogOutDialog",
  data: () => ({
    loading: false,
  }),
  props: {
    reveal: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  methods: {
    ...mapMutations({
      signOut: "auth/SET_AUTH_LOGOUT",
    }),
    cancel() {
      this.$emit("cancel");
    },
    async logout() {
      try {
        this.loading = true;
        await this.axios.post("/auth/revoke-token/");
        this.$emit("logOutSuccess");
      } catch (error) {
        Promise.resolve();
      } finally {
        localStorage.removeItem("access_token");
        this.$emit("logOutSuccess");
        this.loading = false;
        this.signOut();
        this.$snackbar.showMessage({
          content: "Logout Success",
          color: "success",
        });
      }
    },
  },
};
</script>

<style scoped>
</style>
